export const contactMeData = [
  {
    socialMedia: "linkedin",
    payload: {
      link: "https://www.linkedin.com/in/alma-hodzic-2ab68b101/"
    }
  },
  {
    socialMedia: "github",
    payload: {
      link: "https://www.linkedin.com/in/alma-hodzic-2ab68b101/"
    }
  },
  {
    socialMedia: "skype",
    payload: {
      copy: true
    }
  },
  {
    socialMedia: "almahdc@gmail.com",
    payload: {
      mailTo: true,
      copy: true
    }
  }
];
